import a from "./ghl-ui.es830.js";
import m from "./ghl-ui.es831.js";
function s() {
  var r = m(arguments), t = r.text, e = r.options, o = r.metadata;
  return a(t, e, o);
}
export {
  s as default
};
